module.exports = __webpack_public_path__ + "img/labyrinth-login-90.3cb4bc75.svg";